import React from 'react';
import PropTypes from 'prop-types';
import Container from '../PageBuilder/lib/Container';

const PageTitleWidget = ({ title, metaInformation, subTitle, containerSettings }) => (
  <Container className="page-title-widget" settings={containerSettings}>
    <div className="container">
      {metaInformation !== '' ? <h4>{metaInformation}</h4> : ''}
      <h1 className={subTitle === '' ? 'no-margin-bottom' : ''}>{title}</h1>
      {subTitle !== '' ? <h2>{subTitle}</h2> : ''}
    </div>
  </Container>
);

PageTitleWidget.title = 'Page Title';
PageTitleWidget.preview = 'page-title.png';
PageTitleWidget.category = 'Layout';

PageTitleWidget.propTypes = {
  title: PropTypes.string.isRequired,
  metaInformation: PropTypes.string.isRequired,
  subTitle: PropTypes.string.isRequired,
  containerSettings: PropTypes.object.isRequired,
};

PageTitleWidget.defaults = {
  title: 'PAGE TITLE',
  metaInformation: 'Issue #13',
  subTitle: 'Page Description',
  containerSettings: {},
};

PageTitleWidget.adminFields = {
  title: { type: 'text' },
  metaInformation: { type: 'text' },
  subTitle: { type: 'text' },
};

export default PageTitleWidget;
